import { render, staticRenderFns } from "./checkPaymentFailed.vue?vue&type=template&id=215d6c74"
import script from "./checkPaymentFailed.vue?vue&type=script&lang=js"
export * from "./checkPaymentFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports